import React from 'react';
import {IndexLink, Link} from 'react-router';
import * as commonApi from '../../../api/common-api';
import {connect} from 'react-redux';
import Loading from 'react-loading';
import axios from 'axios';

var querystring = require('querystring');
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import ReactDOM from 'react-dom';
import Textarea from 'react-textarea-autosize';

const opt_jobFunction = [{value: "", label: ''}];

//var termArr = [];
class ProfileWork extends React.Component {
    constructor(props) {
        super(props);

        var d = new Date();
        var y = d.getFullYear();
        var dateOptions = this.generateOptions(2010, y);

        var mOps = [
            {value: 'Jan', label: 'Jan'},
            {value: 'Feb', label: 'Feb'},
            {value: 'Mar', label: 'Mar'},
            {value: 'Apr', label: 'Apr'},
            {value: 'May', label: 'May'},
            {value: 'Jun', label: 'Jun'},
            {value: 'Jul', label: 'Jul'},
            {value: 'Aug', label: 'Aug'},
            {value: 'Sep', label: 'Sep'},
            {value: 'Oct', label: 'Oct'},
            {value: 'Nov', label: 'Nov'},
            {value: 'Dec', label: 'Dec'}
        ];
        var my = false;
        if (this.props.user.id_account == this.props.profileId) {
            my = true;
        }
        this.state = {
            loading: false,
            locOptions: [],
            opt_jobFunction: [],
            loadOptions: [],
            isDisabled: false,
            profileId: this.props.profileId,
            my: my,
            expArr: [],
            exps: [],
            comOps: [],
            show: false,
            mOps: mOps,
            dateOptions: dateOptions,
            item: {},
            jobTitleOptions: []
        };
        //profileId = this.props.profileId;
        //this.getCourses = this.getCourses.bind(this);
        //this.getJobFunction();
    }

    generateOptions(from, to) {
        var options = [];
        for (var i = from; i <= to; i++) {
            options.push({value: i.toString(), label: i.toString()});
        }

        return options.slice();
    }


    componentDidMount() {
        this.getJobFunction();
        this.setState({loading: true}, () => {
            this.getExps();
        });
        // axios.get(commonApi.getAPIURL()+'?api=getComps')
        // .then(response => {
        // if(response.data.status == 1)
        // {
        // var array = [];
        // var i = 1;
        // for(var item of response.data.data)
        // {
        // var name = item.name_company ;
// 		    			
        // var img = '';
        // if(item.id_file_company>0)
        // {
        // img = item.file.link_file;
        // }
        // var des = item.city_company+", "+item.state_company;
        // array.push({ value: item.id_company, label: name,des:des, icon: img });
        // i++;
        // }
        // this.setState({comOps:array});
        // //store.dispatch(getUserSuccess(response.data.data));
        // }
        // //console.log(response.data);
// 			      
        // return response;
        // });


    }

    componentWillReceiveProps(nextProps) {
        var my = nextProps.my;
        var loading = false;
        if (nextProps.profileId != this.props.profileId) {
            loading = true;
        }
        if (loading) {
            this.setState({loading: loading, profileId: nextProps.profileId, my: my, expArr: [], exps: []}, () => {
                this.getExps();
            });
        }
        else {
            this.setState({profileId: nextProps.profileId, my: my});
        }


        //profileId = nextProps.profileId;
        //this.getCourses();
    }

    getDateFromString(mon, year) {
        return new Date(Date.parse(mon + " 1, " + year));
    }

    monthDiff(d1, d2) {
        var months;
        months = (d2.getFullYear() - d1.getFullYear()) * 12;
        months -= d1.getMonth() + 1;
        months += d2.getMonth();
        return months + 1;
    }

    getExps() {
        axios.get(commonApi.getAPIURL() + '?api=getExps&user_id=' + this.state.profileId)
            .then(response => {
                if (response.data.status == 1) {
                    var expArr = [];
                    var i = 0;
                    for (var item of response.data.data) {

                        var avatar = item.name.substring(0, 1).toUpperCase();
                        if (item.id_file > 0) {
                            avatar = (<img src={item.file.link_file}/>);
                        }
                        var d1 = this.getDateFromString(item.mstart, item.start);
                        var d2 = new Date();
                        if (item.current == 0) {
                            d2 = this.getDateFromString(item.mend, item.end);
                        }
                        var month = this.monthDiff(d1, d2);
                        var monthstr = month + " months";
                        if (month == 1) {
                            monthstr = month + " month";
                        }

                        let location = item.location
                        if (item.remote == 1) {
                            location = "Remote"
                        }

                        var des = item.mstart + " " + item.start + " - " + item.mend + " " + item.end + " (" + monthstr + ") | " + location;
                        if (item.current == 1) {
                            var des = item.mstart + " " + item.start + " - Present" + " (" + monthstr + ") | " + location;
                        }
                        var style = {};
                        if (i == 0) {
                            style = {border: "none"};
                        }
                        expArr.push(<div key={"exp-item-" + item.id} className="item_box" style={style}>
                            <div className="left_item_box">
                                <div className="image">
                                    {item.id_company != 0 ? (
                                        <Link to={"/company/" + item.id_company}>{avatar}</Link>) : avatar}

                                </div>
                            </div>
                            <div className="right_item_box">
                                <div className="title">{item.title} {item.current == 1 ? (
                                    <div className="primary_tag">Current Position</div>) : ""}</div>
                                <div className="des">{item.name} </div>


                                <div className="des">{des}</div>
                                <div className="des2">{item.des}</div>


                                {this.state.my ? (
                                    <div><a onClick={this.removeExp.bind(this, item)} className="close_btn"><img
                                        src="/static/img/appimg/icon_close_x.png"/></a>
                                        <a onClick={this.editExp.bind(this, item)} className="edit_btn"><img
                                            src="/static/img/appimg/email-icon03.png"/></a></div>) : ""}
                            </div>
                        </div>);
                        i++;
                    }
                    this.setState({exps: response.data.data, expArr: expArr});

                    //store.dispatch(getUserSuccess(response.data.data));
                }
                //console.log(response.data);
                this.setState({loading: false});
                return response;
            });
    }


    optionRenderer(option) {
        var img = option.label.substring(0, 1).toUpperCase();
        if (option.icon != "") {
            img = (<img src={option.icon}/>);
        }
        return (<div className="option_item">
            <div className="option_img">
                {img}
            </div>
            <div className="option_label">
                <span className="name">{option.label}</span><br/>
                <span className="des">{option.des}</span>
            </div>
        </div>);
    }


    onSelectCompany(item) {
        var it = this.state.item;

        it.company = item.value;
        if (item.value == 0) {
            it.name_company = item.label;
        }
        this.setState({item: it});
    }

    onSelectMStart(item) {
        var it = this.state.item;

        it.mstart = item.value;
        this.setState({item: it});
    }

    onSelectMEnd(item) {
        var it = this.state.item;

        it.mend = item.value;
        this.setState({item: it});
    }

    onSelectStart(item) {
        var it = this.state.item;

        it.start = item.value;
        this.setState({item: it});
    }

    onSelectEnd(item) {
        var it = this.state.item;

        it.end = item.value;
        this.setState({item: it});
    }

    handleTxtChange(event) {
        var it = this.state.item;
        it.des = event.target.value;
        this.setState({item: it});

    }

    onCurrentClick(e) {
        var it = this.state.item;
        if (it.current == undefined) {
            it.current = true;
        }
        else {
            it.current = !it.current;
        }
        if (it.current) {
            it.mend = "";
            it.end = 0;
        }
        //var val = !this.state.paid;
        this.setState({item: it});

    }

    onRemoteClick(e) {
        var it = this.state.item;
        var isDisabled = this.state.isDisabled;
        if (it.remote == undefined) {
            it.remote = true;
        }
        else {
            it.remote = !it.remote;
        }
        if (it.remote) {
            it.location = "";
            isDisabled = true
        }
        else {
            isDisabled = false
        }
        //var val = !this.state.paid;
        this.setState({item: it, isDisabled: isDisabled});

    }

    // onTitleChange(e)
    // {
    // 	var it = this.state.item;
    // 	it.title=e.target.value;
    // 	this.setState({item:it});
    // }
    onLocationChange(item) {
        var it = this.state.item;
        it.location = item.value;
        this.setState({item: it});
    }

    addClick(e) {
        this.setState({show: true, item: {}})
    }

    save(e) {
        var item = this.state.item;
        if (item.title == undefined || item.title.trim().length == 0) {
            commonApi.showAlert("Please enter title");
            return;
            //return;
        }
        if (item.company == undefined) {
            commonApi.showAlert("Please select your company");
            return;
        }
        if ((item.location == undefined || item.location.trim().length == 0) && (item.remote == undefined || item.remote == false)) {
            commonApi.showAlert("Please enter location");
            return;
            //return;
        }

        if (item.mstart == undefined || item.start == undefined) {
            commonApi.showAlert("Please select your time period");
            return;
        }
        if (item.current != true && (item.mend == undefined || item.end == undefined || item.mend == "" || item.end == 0)) {
            commonApi.showAlert("Please select your time period");
            return;
        }
        // if(item.des == undefined || item.des.trim().length == 0)
        // {
        // 	commonApi.showAlert("Please enter description");
        // 	return;
        // 	//return;
        // }
        var d1 = this.getDateFromString(item.mstart, item.start);
        var d2 = new Date();
        if (item.current == undefined || item.current == false || item.current == 0) {
            d2 = this.getDateFromString(item.mend, item.end);
        }
        var month = this.monthDiff(d1, d2);
        if (month <= 0) {
            commonApi.showAlert("Your time period not valid");
            return;
        }


        if (item.id == undefined) {
            item.id = 0;
            //return;
        }
        if (item.current == undefined) {
            item.current = 0;
            //return;
        }
        if (item.remote == undefined) {
            item.remote = 0;
            //return;
        }

        if (item.mend == undefined) {
            item.mend = "";
            //return;
        }
        if (item.current == true) {
            item.current = "1";
            item.mend = "";
            item.end = "0";
        }
        else {
            item.current = "0";
        }
        if (item.remote == true) {
            item.remote = "1";
        }
        else {
            item.remote = "0";
        }


        var data = new FormData();
        data.append('id', item.id);
        data.append('company', item.company);
        data.append('mend', item.mend);
        data.append('end', item.end);
        data.append('start', item.start);
        data.append('mstart', item.mstart);
        data.append('title', item.title);
        data.append('job_function', item.job_function);
        data.append('des', item.des);
        data.append('current', item.current);
        data.append('remote', item.remote);
        data.append('location', item.location);
        if (item.company == 0) {
            data.append('name_company', item.name_company);
        }
        data.append('user_id', this.state.profileId);
        axios.post(commonApi.getAPIURL() + '?api=updateExp', data)
            .then(response => {
                if (response.data.status == 1) {
                    this.setState({show: false, item: {}});

                    this.getExps();


                }

                //console.log(response.data);

                return response;
            }).catch(error => {

        });

    }

    getJobFunction() {
        this.setState({loading: true});
        var url = "/code/apis.php?api=getParams&opt_param=job_function";
        var data = new FormData();
        axios.post(url, data)
            .then(response => {
                if (response.data.status == 1) {
                    this.setState({opt_jobFunction: response.data.data});
                }
                this.setState({loading: false});
                return response;
            }).catch(error => {
            this.setState({loading: false});
        });
    }


    cancel(e) {
        this.setState({show: false, item: {}});
    }

    editExp(it, e) {
        var item = Object.assign({}, it);
        if (item.id_file > 0) {
            item.img = (<img src={item.file.link_file}/>);
        }
        else {
            item.img = item.name.substring(0, 1).toUpperCase();
        }

        var locOptions = [];
        if (item.location.length > 0)
            locOptions = [
                {value: item.location, label: item.location},

            ];
        item.company = item.id_company;
        item.current = item.current == 0 ? false : true;
        item.remote = item.remote == 0 ? false : true;
        item.edit = true;
        var array = [];
        var img = '';
        if (item.id_file > 0) {
            img = item.file.link_file;
        }
        array.push({value: item.id_company, label: item.name, des: item.des, icon: img});
        var jobTitle_arr = [{value: item.title, label: item.title}];
        this.setState({
            comOps: array,
            locOptions: locOptions,
            opt_jobFunction: opt_jobFunction,
            loadOptions: locOptions,
            show: true,
            item: item,
            jobTitleOptions: jobTitle_arr
        }, () => {
            this.getJobFunction();
			if (this.refs.title != undefined) this.refs.title.focus();
        });
        console.log(this.state.comOps)

    }

    removeExp(it, e) {
        var data = new FormData();
        data.append('id', it.id);

        axios.post(commonApi.getAPIURL() + '?api=removeExp', data)
            .then(response => {
                if (response.data.status == 1) {
                    this.setState({show: false, item: {}});

                    this.getExps();


                }

                //console.log(response.data);

                return response;
            }).catch(error => {

        });
    }

    getLocationOptions(input) {
        if (input.length == 0 || input.length < 2) {


            //this.setState({location:""});
            this.setState({loadOptions: this.state.loadOptions});
        }
        else {

            var data = new FormData();

            data.append('search', input);


            axios.post(commonApi.getAPIURL() + '?api=searchJobLocation&we=1', data, {
                progress: (progressEvent) => {

                }
            })
                .then(response => {
                    if (response.data.status == 1) {
                        this.setState({loadOptions: response.data.data});
                        //callback(null,{options:response.data.data});
                    }
                    else {
                        //callback(null,{options:[]});
                    }
                    //console.log(response.data);

                    return response;
                }).catch(error => {
                //callback(null,{options:[]});
            });

        }
        //console.log(callback);

        //return testop;
    }

    getCompOptions(input) {
        if (input.length == 0 || input.length < 2) {


            //this.setState({location:""});
            this.setState({comOps: this.state.comOps});
        }
        else {

            var data = new FormData();

            data.append('search', input);


            axios.post(commonApi.getAPIURL() + '?api=searchCompany', data, {
                progress: (progressEvent) => {

                }
            })
                .then(response => {
                    if (response.data.status == 1) {
                        var array = [];
                        var i = 1;
                        for (var item of response.data.data) {
                            var name = item.name_company;

                            var img = '';
                            if (item.id_file_company > 0) {
                                img = item.file.link_file;
                            }
                            var des = item.city_company;
                            array.push({value: item.id_company, label: name, des: des, icon: img});
                            i++;
                        }
                        if (array.length == 0) {
                            array.push({value: 0, label: input, des: "", icon: ""});
                        }

                        this.setState({comOps: array});
                        //callback(null,{options:response.data.data});
                    }
                    else {
                        //callback(null,{options:[]});
                    }
                    //console.log(response.data);

                    return response;
                }).catch(error => {
                //callback(null,{options:[]});
            });

        }
        //console.log(callback);

        //return testop;
    }

    getJobTitleOptions(input, callback) {
        if (input.length == 0) {
            this.setState({jobTitleOptions: this.state.jobTitleOptions});
        }
        else {
            var data = new FormData();
            data.append('search', input);
            axios.post('code/apis.php?api=getParams&opt_param=job_title&opt_lable=true', data, {
                progress: (progressEvent) => {
                }
            })
                .then(response => {
                    if (response.data.status == 1) {
                        this.setState({jobTitleOptions: response.data.data});
                    } else {
                        this.setState({jobTitleOptions: []});
                    }
                    return response;
                })
                .catch(error => {
                    callback(null, {options: []});
                });
        }
    }

    handleJobTitleChange = (event) => {
        var it = this.state.item;
        it.title = event.target.value;
        this.setState({item: it});
    }

    handleJobFunctionChange(event) {
        const it = this.state.item;
        it['job_function'] = event.value
        this.setState({item: it});
    }

    render() {
        // if(this.state.terms == undefined){
        // return (
        // <div className="page_course_box profile_content_wrapper">
        // <div >
        // <div style={{color:"#545454"}}><Loading delay={0} type='spinningBubbles' color='rgba(84, 84, 84, 1)' width="20px" height="20px" /> Loading</div>
        // </div>
// 					
        // </div>
        // );
        // }


        return (
            <div
                className={(this.state.my || this.state.expArr.length > 0) ? "page_course_box profile_content_wrapper" : "hide-el"}>
                <div className="title_box">
                    <img src="/static/img/appimg/icon_exp.png"/>
                    <div className="title">
                        Work Experience
                    </div>
                </div>
                {this.state.show ? (<div className="edit_box">
                    <div className="left_edit_box">
                        <div className="image">
                            {this.state.item.img}
                        </div>
                    </div>
                    <div className="right_edit_box">
                        <div className="edit_item">
                            <div className="title">Job Title <label className="checkbox-inline fright"><input
                                type="checkbox" value="" onClick={this.onCurrentClick.bind(this)}
                                checked={this.state.item.current}/> Current Position</label></div>
                            <div>
                                <input
                                    name="title"
                                    value={this.state.item.title}
                                    onChange={this.handleJobTitleChange.bind(this)}
                                    type="text"
                                    placeholder="Enter the job which you worked..."
                                    className="form-control input-md"
                                />
                            </div>
                        </div>
                        <div className="edit_item">
                            <div className="title">Job function</div>
                            <div>
                                <Select
                                    name="job_function"
                                    className="select_box"
                                    value={this.state.item.job_function}
                                    options={this.state.opt_jobFunction}
                                    onChange={this.handleJobFunctionChange.bind(this)}
                                    //onInputChange={this.getJobFunctionOptions.bind(this)}
                                    placeholder=""
                                    clearable={false}
                                    searchable={false}
                                />
                            </div>
                        </div>
                        <div className="edit_item">
                            <div className="title">Employer</div>
                            <div><Select
                                value={this.state.item.company}
                                onChange={this.onSelectCompany.bind(this)}
                                placeholder="Start typing to find your employer..."
                                options={this.state.comOps}
                                optionRenderer={this.optionRenderer}

                                noResultsText="No employer found"
                                searchPromptText="Enter at least 2 charactors"
                                onInputChange={this.getCompOptions.bind(this)}
                                clearable={false}
                                searchable={true}
                                allowCreate={true}
                            /></div>


                        </div>
                        <div className="edit_item inline_block">
                            <div className="title">Time Period</div>
                            <div className="div_50" style={{paddingRight: "10px"}}>
                                <div>Start Date</div>
                                <div className="inline_block">
                                    <div className="div_50" style={{paddingRight: "5px"}}>
                                        <Select
                                            value={this.state.item.mstart}
                                            onChange={this.onSelectMStart.bind(this)}
                                            placeholder=""
                                            options={this.state.mOps}
                                            clearable={false}
                                            searchable={false}
                                        />
                                    </div>
                                    <div className="div_50">
                                        <Select
                                            value={this.state.item.start}
                                            onChange={this.onSelectStart.bind(this)}
                                            placeholder=""
                                            options={this.state.dateOptions}
                                            clearable={false}
                                            searchable={false}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="div_50" style={{paddingLeft: "10px"}}>
                                <div>End Date</div>
                                <div className="inline_block">
                                    <div className="div_50" style={{paddingRight: "5px"}}>
                                        <Select
                                            value={this.state.item.mend}
                                            onChange={this.onSelectMEnd.bind(this)}
                                            placeholder=""
                                            options={this.state.mOps}
                                            clearable={false}
                                            searchable={false}
                                        />
                                    </div>
                                    <div className="div_50">
                                        <Select
                                            value={this.state.item.end}
                                            onChange={this.onSelectEnd.bind(this)}
                                            placeholder=""
                                            options={this.state.dateOptions}
                                            clearable={false}
                                            searchable={false}
                                        />
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="edit_item">
                            <div className="title">Location</div>
                            <div><Select
                                name="location"
                                className="select_box"
                                value={this.state.item.location}
                                options={this.state.loadOptions}
                                onChange={this.onLocationChange.bind(this)}
                                onInputChange={this.getLocationOptions.bind(this)}
                                placeholder="Enter the city in which you worked..."
                                clearable={false}
                                disabled={this.state.isDisabled}
                                searchable={true}
                            /></div>


                        </div>
                        <div className="edit_item">
                            <label className="checkbox-inline fleft">
                                <input
                                    type="checkbox" value="" onClick={this.onRemoteClick.bind(this)}
                                    checked={this.state.item.remote}/> Remote</label>
                        </div>

                        <div className="edit_item clearfix">
                            <div className="title">Description</div>
                            <div>
                                <Textarea placeholder="Type your work experience here" name="content"
                                          onChange={this.handleTxtChange.bind(this)} value={this.state.item.des}/>
                            </div>


                        </div>

                        <div className="edit_item">
                            <div className="title"></div>
                            <a onClick={this.save.bind(this)} className="btn_v btn_confirm fright">Save</a>
                            <a onClick={this.cancel.bind(this)} style={{marginRight: "10px"}}
                               className="btn_v btn_cancel fright">Cancel</a>

                        </div>
                    </div>
                </div>) : (
                    <div className={this.state.my ? "add_box clickable" : "hide-el"} onClick={this.addClick.bind(this)}>
                        <div className="left_add_box">
                            <img src="/static/img/appimg/icon_add_black.png"/>
                        </div>
                        <div className="right_add_box">
                            <div className="title">Add your current or previous job expericences</div>
                            <div className="des"><img src="/static/img/appimg/icon_i.png"/> you can find an example below
                            </div>
                        </div>
                    </div>)}
                {this.state.expArr.length == 0 && this.state.loading == false ? (<div className="item_box op07">
                    <div className="left_item_box">
                        <div className="image">
                            V
                        </div>
                    </div>
                    <div className="right_item_box">
                        <div className="title">Summer Marketing</div>
                        <div className="des">Versity</div>


                        <div className="des">Jul 2024 - Present</div>
                        <div className="des">- Helped build brand presence across social media flatforms, converting 800
                            customers into followers.
                        </div>


                    </div>
                </div>) : ""}

                {this.state.expArr}


            </div>

        )
    }
}

export default ProfileWork;


/** WEBPACK FOOTER **
 ** ./src/client/app/appcomponents/commons/profile/profile_work.js
 **/